import { useGetCBBOListQuery } from "features/onboarding/organizations/FarmersGroup/CBBO/CBBOApiSlice";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomSearchBar from "components/CustomSearchBar";
import { Button, Modal } from "react-bootstrap";
import useDebouncedValue from "hooks/useDebouncedValue";
import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import SkeletonLoader from "features/Procurement/common/SkeletonLoader";
import NoResponse from "./NoResponse";
import { ProjectModalComponent } from "./ProjectModalComponent";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { ProjectOnboardTrader } from "./ProjectOnboardTrader";
import { Tabs } from "antd";
const AllProjectComponent = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const [addModel, setAddModel] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const debouncedSearch = useDebouncedValue(searchKey);
  const [defaultValue, setDefaultValue] = useState(null);
  const [updateModel, setUpdateModel] = useState(false);
  const { data: data, isLoading, refetch } = useGetCBBOListQuery({
    pagination,
    searchKey: debouncedSearch || "",
  });

  useEffect(() => {
    const filteredData = data?.data?.results?.filter(
      (item) => item.project !== null
    );
    setUsers(filteredData);
  }, [data]);

  const handleAddFpoModel = (addFpo, FpoData, type) => {
    if (type === "update") {
      setUpdateModel(true);
    }
    setAddModel(true);
    if (addFpo) {
      setDefaultValue(null);
    } else {
      setDefaultValue({
        projectId: FpoData.id,
        phone_number: FpoData.phone_number,
        email: FpoData.email,
        organization_category: FpoData?.organization_category,
        organization_sector: FpoData?.organization_sector,
        organization_type: FpoData?.organization_type,
        fullData: FpoData?.project,
        address: FpoData.address,
        PAN: FpoData.PAN,
        GSTIN: FpoData.GSTIN,
        pincode: FpoData.pincode,
      });
    }
  };
  return (
    <div className="mt-lg-0 mt-md-0">
      <Box mb={3}>
        <Grid container spacing={2} alignItems="">
          <Grid item xs={12} md={4} className="d-flex align-items-center">
            <CustomSearchBar sendSearchFunction={setSearchKey} />
          </Grid>

          <Grid item xs={12} md={8}>
            <Box
              display="flex"
              justifyContent={{ xs: "flex-start", md: "flex-end" }}
              alignItems="center"
              flexWrap="wrap"
              gap={2}
            >
              <Typography variant="body1">
                Total Projects:{" "}
                <strong className="text-success">{users?.length || 0}</strong>
              </Typography>
              <Button
                size="sm"
                className="float-end d-flex align-items-center"
                onClick={() => handleAddFpoModel(true, null)}
              >
                <span className=""> Add Project </span> &nbsp;
                <i className="mdi mdi-account-plus fs-6 "></i>
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {isLoading ? (
        <SkeletonLoader />
      ) : users?.length > 0 ? (
        <Grid container spacing={4}>
          {users?.map((project, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <Card
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  px: 1,
                  py: 1,
                  backgroundColor: "#f9f9f9",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                }}
              >
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={7}>
                      <Stack spacing={1}>
                        <Box>
                          <Typography
                            variant="h6"
                            fontWeight={600}
                            className="text-capitalize"
                          >
                            📋 {project.organization_name}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Created on:{" "}
                            {project?.created_at
                              ? new Date(
                                  project.created_at
                                ).toLocaleDateString()
                              : "-"}
                          </Typography>
                        </Box>
                        <Typography variant="body2" color="text.secondary">
                          <PhoneIcon
                            fontSize="small"
                            sx={{ mr: 0.5, color: "#eda946" }}
                          />
                          {project.phone_number || "N/A"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          <EmailIcon
                            fontSize="small"
                            sx={{ mr: 0.5, color: "#eda946" }}
                          />
                          {project.email || "N/A"}
                        </Typography>
                        <Box>
                          <Typography variant="caption" color="text.secondary">
                            📍 Project Location:
                          </Typography>
                          <Typography variant="body2" fontWeight={500}>
                            {project?.project?.states
                              ?.map((state, index) => {
                                const district =
                                  project?.project?.districts?.[index];
                                const stateName = state?.label;
                                const districtName = district?.label;
                                return districtName
                                  ? `${stateName} | ${districtName}`
                                  : stateName;
                              })
                              .join(", ") || "-"}
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <Box
                        sx={{
                          float: { xs: "none", sm: "right" },
                          mt: { xs: 2, sm: 0 },
                        }}
                      >
                        <Typography variant="body2" fontWeight={500} mb={1}>
                          🌾 Crops:
                        </Typography>
                        {project?.project?.crops?.length ? (
                          <Stack direction="row" flexWrap="wrap" gap={1} mt={1}>
                            {project.project.crops.map((crop, i) => (
                              <Box
                                key={i}
                                sx={{
                                  px: 1.5,
                                  py: 0.5,
                                  fontSize: "0.75rem",
                                  backgroundColor: "#ffe0b2",
                                  color: "#bf360c",
                                  borderRadius: "12px",
                                  fontWeight: 500,
                                }}
                              >
                                {crop}
                              </Box>
                            ))}
                          </Stack>
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            -
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  </Grid>

                  <Box
                    mt={2}
                    display="flex"
                    flexDirection={{ xs: "row", sm: "row" }}
                    justifyContent="flex-end"
                    gap={1}
                  >
                    <Button
                      size="sm"
                      onClick={() =>
                        handleAddFpoModel(false, project, "update")
                      }
                      sx={{ textTransform: "none", borderRadius: 2 }}
                    >
                      Update
                    </Button>
                    <Link to={`/project/dashboard/${project.id}`}>
                      <Button
                        size="sm"
                        className="backgroundColorBeige "
                        onClick={() => {
                          localStorage.setItem("projectId", project.id);
                        }}
                        sx={{ textTransform: "none", borderRadius: 2 }}
                      >
                        View
                      </Button>
                    </Link>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <NoResponse />
      )}

      <Modal
        show={addModel}
        onHide={() => {
          setAddModel(false);
          setUpdateModel(false);
          // resetFormStates();
        }}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className=" text-primary m-0 ">
              📋 {updateModel ? "Update" : "Add"} CBBO Project
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {/* <ProjectModalComponent
            refetch={refetch}
            active="CBBO"
            setAddModel={setAddModel}
            defaultValue={defaultValue}
          /> */}
          <Tabs
            items={[
              {
                key: "Onboard as a Project",
                label: "Onboard as a Project",
                children: (
                  <div className="">
                    <ProjectModalComponent
                      refetch={refetch}
                      active="CBBO"
                      setAddModel={setAddModel}
                      defaultValue={defaultValue}
                    />
                  </div>
                ),
              },
              {
                key: "Onboard as a Trader",
                label: "Onboard as a Trader",
                children: (
                  <ProjectOnboardTrader
                    refetch={refetch}
                    active="CBBO"
                    setAddModel={setAddModel}
                    defaultValue={defaultValue}
                    traderOnboard={true}
                  />
                ),
              },
            ]}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AllProjectComponent;
